import Model from './Model'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export default class Customer extends Model {
  resource() {
    return 'customers'
  }

  get addedDate() {
    return dayjs.utc(this.created_at).format('MMM DD, YYYY hh:mm A')
  }

  get path() {
    return {
      name: 'customer.details',
      params: {
        id: this.customer_id,
      },
    }
  }
}
